export const stringToCurrency = (string) => {
    let currency = string?`$${string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`:'';
    return currency;
}